export default __webpack_public_path__ + "static/ISO-IEC-27001-7a9e58ef8a5591277f2ceb240018fc1b.png";